import { atom, selector } from 'recoil'

export const windowWidthState = atom({
  key: 'WindowWidth',
  default: window.innerWidth
})

export const isLgSizeValue = selector({
  key: 'IsLgSize',
  get: ({ get }) => get(windowWidthState) <= 1200,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const isMdSizeValue = selector({
  key: 'IsMdSize',
  get: ({ get }) => get(windowWidthState) <= 996,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const isXsSizeValue = selector({
  key: 'IsXsSize',
  get: ({ get }) => get(windowWidthState) <= 480,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const isPadValue = selector({
  key: 'IsPad',
  get: ({ get }) => get(windowWidthState) <= 1024,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})

export const isMobileValue = selector({
  key: 'IsMobile',
  get: ({ get }) => get(windowWidthState) <= 768,
  cachePolicy_UNSTABLE: {
    eviction: 'most-recent'
  }
})
